import React from 'react';
import { FormattedMessage } from "../../../util/reactIntl";
import { ExternalLink, NamedLink } from '../../../components';
import config from '../../../config';

import css from './SectionTeachersSubjectsByState.module.css';
import { getLetterType } from '../../../util/lettersHelper';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const SectionTeachersSubjectsByState = props => {
  const { areasCertified, state, subject, content } = props;

  const allInAreasCertified = areasCertified.filter(i => i.allIn);
  const searchParams = parent =>  allInAreasCertified.filter(i => i.parent === parent).map(({ key }) => key).join(',');

  const filteredAreasCertified = areasCertified.filter(i => subject ? i.parent === subject.parent : i.allIn).sort(function (a, b) {
    if (a.parent < b.parent) return -1;
    if (a.parent > b.parent) return 1;
    return 0;
  });

  let article = 'a';
  if(subject) {
    const firstLetterOfCurrentSubject = subject?.label?.substring(0, 1).toLowerCase();
    const letterTypeObject = getLetterType(firstLetterOfCurrentSubject);
    const letterType = letterTypeObject.type;
    article = letterType === 'vowel' ? 'an' : 'a';
  }

  return <div>
    <div className={css.rootTitleHolder}>
      <h2 className={css.rootTitle}>
        {content?.findTitle ?
          content.findTitle :
          state && !subject ?
            <FormattedMessage values={{ state: state?.label }} id='SectionTeachersSubjectsByState.stateTitle' /> :
            state && subject ?
              <FormattedMessage values={{ state: state?.label, subject: subject.parent}} id='SectionTeachersSubjectsByState.subjectTitle' /> :
          <FormattedMessage id="SectionTeachersSubjectsByState.title" />
        }
      </h2>
    </div>

    <p className={css.rootDescription}>
      {content?.findDescription ?
        content.findDescription :
        state && !subject ?
          <FormattedMessage values={{ state: state?.label }} id='SectionTeachersSubjectsByState.stateSubtitle' /> :
          state && subject ?
            <FormattedMessage values={{ state: state?.label, subject: subject.parent, article}} id='SectionTeachersSubjectsByState.subjectSubtitle' /> :
        <FormattedMessage id="SectionTeachersSubjectsByState.subtitle" />
      }
    </p>

    <ul className={filteredAreasCertified.length < 10 ? classNames(css.list, css.listCentered) : css.list}>
    {filteredAreasCertified.map(i => {
       return ( <li className={css.item}>
         {subject ? (<ExternalLink
             href={`/s?pub_state=has_any:${state.key}&pub_subjects=has_any:${subject ? i.key : searchParams(i.parent)}&type=teacher`}
             className={css.link}
           >
             {subject ? i.label : i.parent}
           </ExternalLink>) :

           (<Link className={css.link} to={`/teachers/${state.short}/${i.staticUrl}`}>
             {subject ? i.label : i.parent}
           </Link>)}
        </li>);
      }
    )}
    </ul>
  </div>;
};

SectionTeachersSubjectsByState.defaultProps = {
  areasCertified: config.custom.areasCertifiedOptions,
};

export default SectionTeachersSubjectsByState;
